import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";

const epcrDispositionSlice = createSlice({
    name: 'epcrDisposition',
    initialState: {
        defs: []
    },
    reducers: {
        setDefs: (state, action) => {
            state.defs = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => epcrDispositionSlice.getInitialState());
    }
});
// #region network operations
const fetchEpcrDispositions = (network) => network.get('/api/v1/dispositions', epcrDispositionSlice.actions.setDefs);
// #endregion

// #region selectors
const selectEpcrDispositions = state => state.epcrDisposition.defs;
// #endregion

export const [useEpcrDispositions, realizeEpcrDispositions] = dataHookFactory(selectEpcrDispositions, { run: fetchEpcrDispositions });

const reducerDetails = { name: epcrDispositionSlice.name, reducer: epcrDispositionSlice.reducer };
export default reducerDetails;